import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AppComponent } from "src/app/app.component";
import { CrudHttp } from "src/app/helpers/CrudHttp";
import { Utilerias } from "src/app/helpers/Utilerias";
import { RelPreguntaRespuesta, RespuestasDTO } from "src/app/types/type";
import { PasoCincoService } from "src/app/services/checklist/paso-cinco.service";
declare var $: any;

@Component({
  selector: "app-checklist-paso5",
  templateUrl: "./checklist-paso5.component.html",
  styleUrls: ["./checklist-paso5.component.css"],
})
export class ChecklistPaso5Component implements OnInit {
  idChecklist: number;
  idTipoRevision: number;
  title: string;
  item: object;
  rubros: any;
  bloques: any;
  bloqueEdit: any;
  subMenus: {
    active: boolean;
    child: boolean;
    label: string;
    router: string;
    class: string;
  }[];
  preguntaEdit: any;
  tipoRespuestas: object;
  crud: CrudHttp;
  disabledBtnResp = false;

  constructor(
    private pasoCincoService: PasoCincoService,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private father: AppComponent
  ) {
    father.moduleName = "Configuracion";

    this.idChecklist = parseInt(this.activatedRoute.snapshot.params.id);
    this.idTipoRevision = parseInt(this.activatedRoute.snapshot.params.idrevision);

    this.title = "Checklist paso 5";

    this.crud = new CrudHttp(http);
    this.crud.methodGet =
      "GetConfiguracionChecklist?idChecklist=" + this.idChecklist;
    this.crud.methodPut = "UpdateRelPreguntaRespuestas";

    this.bloqueEdit = {
      Nombre: "",
      Ponderacion: 100,
      Orden: 1,
    };

    this.preguntaEdit = {
      Descripcion: "",
      Ponderacion: 100,
      Orden: 1,
    };
  }

  ngOnInit() {
    this.loadSubMenu();
    this.dataBind(this.crud, "bloques");
  }

  frmPostRespuestas(rubro) {
    this.disabledBtnResp = true;

    let obj: RelPreguntaRespuesta[] = [];
    for (let pregunta of rubro.Preguntas) {
      for (let respuesta of pregunta.Respuestas) {
        obj.push(respuesta);
      }
    }
    const respuestas: RespuestasDTO = {
      respuestas: obj,
    }
    this.pasoCincoService.updateRelPreguntaRespuestas(respuestas)
      .subscribe(resp => {
        if (resp.Result.Exito) {
          this.disabledBtnResp = false;
        }
      });
  }

  dataBind(crud, sourceName) {
    crud.get().then((res) => {
      this[sourceName] = res;
      Utilerias.showLoader(false);
    });
  }

  loadSubMenu() {
    var items = [
      {
        active: false,
        child: true,
        label: "Paso 1",
        router: `../../../ChecklistPaso1/${this.idChecklist}/${this.idTipoRevision}`,
        class: "submenu__item d-flex align-items-center",
      },
      {
        active: false,
        child: true,
        label: "Paso 2",
        router: `../../../ChecklistPaso2/${this.idChecklist}/${this.idTipoRevision}`,
        class: "submenu__item d-flex align-items-center",
      },
      {
        active: false,
        child: true,
        label: "Paso 3",
        router: `../../../ChecklistPaso3/${this.idChecklist}/${this.idTipoRevision}`,
        class: "submenu__item d-flex align-items-center",
      },
      {
        active: false,
        child: true,
        label: "Paso 4",
        router: `../../../ChecklistPaso4/${this.idChecklist}/${this.idTipoRevision}`,
        class: "submenu__item d-flex align-items-center",
      },
      {
        active: true,
        child: false,
        label: "Paso 5",
        router: null,
        class: "submenu__item submenu--active d-flex align-items-center",
      },
    ];
    this.subMenus = items;
  }

  ValidaPonderacion(event: any) {
    let valor = event.target.value;

    if (parseInt(valor) > 100) {
      Utilerias.alertClient('Ponderación', 'El valor de la ponderación no debe ser mayor a 100', 0);
    }

    if (valor.length >= 3) {

      return false;
    }
    return true;
  }
}
